import React, { useState } from 'react';
import { feedback } from '../api';

function Feedback() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    setError('');

    try {
      await feedback.create(formData);
      setSubmitted(true);
      setSending(false);
      setFormData({ name: '', email: '', subject: '', message: '' });
      
      // Скрываем сообщение через 5 секунд
      setTimeout(() => {
        setSubmitted(false);
      }, 5000);
    } catch (err) {
      setSending(false);
      const errorMessage = err.response?.data?.detail || err.message || 'Ошибка отправки сообщения';
      setError(errorMessage);
    }
  };

  return (
    <>
      <div className="max-w-4xl mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">
          Обратная связь
        </h1>

        {submitted && (
          <div className="mb-6 p-4 bg-green-50 border border-green-200 rounded-lg">
            <p className="text-green-800 font-medium">
              Спасибо за ваше сообщение! Мы свяжемся с вами в ближайшее время.
            </p>
          </div>
        )}

        {error && (
          <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-lg">
            <p className="text-red-800 font-medium">
              Ошибка: {error}
            </p>
          </div>
        )}

        <div className="grid md:grid-cols-2 gap-8">
          {/* Контактная информация */}
          <div className="space-y-6">
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
              <h2 className="text-xl font-semibold text-gray-900 mb-4">
                Контактная информация
              </h2>
              
              <div className="space-y-4">
                <div>
                  <h3 className="text-sm font-semibold text-gray-700 mb-2">
                    Рабочая почта
                  </h3>
                  <a 
                    href="mailto:skillgate.pro@gmail.com"
                    className="text-blue-600 hover:text-blue-800 hover:underline"
                  >
                    skillgate.pro@gmail.com
                  </a>
                  <p className="text-sm text-gray-500 mt-1">
                    Для общих вопросов и поддержки
                  </p>
                </div>

                <div className="pt-4 border-t border-gray-200">
                  <h3 className="text-sm font-semibold text-gray-700 mb-2">
                    Срочные вопросы
                  </h3>
                  <a 
                    href="mailto:sergei.vikhliaev@gmail.com"
                    className="text-blue-600 hover:text-blue-800 hover:underline font-medium"
                  >
                    sergei.vikhliaev@gmail.com
                  </a>
                  <p className="text-sm text-gray-500 mt-1">
                    Для срочных вопросов и экстренных ситуаций
                  </p>
      </div>

                <div className="pt-4 border-t border-gray-200">
                  <h3 className="text-sm font-semibold text-gray-700 mb-2">
                    Время ответа
                  </h3>
                  <p className="text-gray-600 text-sm">
                    Мы стараемся отвечать на все обращения в течение <strong>24 часов</strong> в рабочие дни.
                  </p>
                  <p className="text-gray-600 text-sm mt-2">
                    На срочные вопросы отвечаем в течение <strong>4 часов</strong> в рабочее время.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-blue-50 rounded-lg border border-blue-200 p-6">
              <h3 className="text-lg font-semibold text-blue-900 mb-3">
                Часто задаваемые вопросы
              </h3>
              <div className="space-y-3 text-sm text-blue-800">
                <div>
                  <p className="font-medium mb-1">Как пополнить баланс?</p>
                  <p className="text-blue-700">
                    Перейдите во вкладку "Оплата" в меню. Там вы найдете реквизиты и QR-код для оплаты через СБП.
                  </p>
                </div>
                <div>
                  <p className="font-medium mb-1">Как создать тест-схему?</p>
                  <p className="text-blue-700">
                    Подробная инструкция доступна во вкладке "Инструкция" в меню.
                  </p>
                </div>
                <div>
                  <p className="font-medium mb-1">Технические проблемы?</p>
                  <p className="text-blue-700">
                    Опишите проблему в форме обратной связи или напишите на рабочую почту.
        </p>
                </div>
              </div>
            </div>
          </div>

          {/* Форма обратной связи */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">
              Напишите нам
            </h2>
            
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                  Ваше имя <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  required
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                  placeholder="Иван Иванов"
                />
              </div>

              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                  Email <span className="text-red-500">*</span>
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  required
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                  placeholder="your@email.com"
                />
              </div>

              <div>
                <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-2">
                  Тема <span className="text-red-500">*</span>
                </label>
                <select
                  id="subject"
                  name="subject"
                  required
                  value={formData.subject}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all bg-white"
                >
                  <option value="">Выберите тему</option>
                  <option value="general">Общий вопрос</option>
                  <option value="technical">Техническая проблема</option>
                  <option value="payment">Вопрос по оплате</option>
                  <option value="feature">Предложение функции</option>
                  <option value="other">Другое</option>
                </select>
              </div>

              <div>
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                  Сообщение <span className="text-red-500">*</span>
                </label>
                <textarea
                  id="message"
                  name="message"
                  required
                  rows={6}
                  value={formData.message}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all resize-none"
                  placeholder="Опишите ваш вопрос или проблему..."
                />
              </div>

              <button
                type="submit"
                disabled={sending}
                className="w-full bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:shadow-lg transition-all disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {sending ? 'Отправка...' : 'Отправить сообщение'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default Feedback;

